import type { TkDict } from "./types";

const dict: TkDict = {
  uz: {
    "tk.catalog.crumbs_label": "Sahifa yo'li",
    "tk.catalog.title_1": "Taklifnoma",
    "tk.catalog.title_2": "shablonlari",
    "tk.catalog.lead_types": "To'y, nikoh, tug'ilgan kun, beshik to'yi, sunnat to'yi, yubiley va korporativ tadbirlar uchun.",
    "tk.catalog.lead_author": "Har biri — dizaynerlarimizning mualliflik ishi.",
    "tk.catalog.search_placeholder": "Shablon nomi",
    "tk.catalog.search_label": "Shablon nomi bo'yicha qidirish",
    "tk.catalog.search_toggle": "Qidirish",
    "tk.catalog.shown": "{total} tadan {shown} tasi ko'rsatildi",
    "tk.catalog.more": "Yana ko'rsatish",
    "tk.catalog.empty_hint": "Boshqa nom yoki toifani tanlab ko'ring.",
  },
  ru: {
    "tk.catalog.crumbs_label": "Навигационная цепочка",
    "tk.catalog.title_1": "Шаблоны",
    "tk.catalog.title_2": "приглашений",
    "tk.catalog.lead_types": "Для свадеб, никаха, дней рождения, бешик-тоя, суннат-тоя, юбилеев и корпоративных мероприятий.",
    "tk.catalog.lead_author": "Каждый — авторская работа наших дизайнеров.",
    "tk.catalog.search_placeholder": "Название шаблона",
    "tk.catalog.search_label": "Поиск по названию шаблона",
    "tk.catalog.search_toggle": "Поиск",
    "tk.catalog.shown": "Показано {shown} из {total}",
    "tk.catalog.more": "Показать ещё",
    "tk.catalog.empty_hint": "Попробуйте другое название или категорию.",
  },
  en: {
    "tk.catalog.crumbs_label": "Breadcrumb",
    "tk.catalog.title_1": "Invitation",
    "tk.catalog.title_2": "templates",
    "tk.catalog.lead_types": "For weddings, nikah ceremonies, birthdays, cradle ceremonies, circumcision celebrations, anniversaries and corporate events.",
    "tk.catalog.lead_author": "Each one is an original work by our designers.",
    "tk.catalog.search_placeholder": "Template name",
    "tk.catalog.search_label": "Search by template name",
    "tk.catalog.search_toggle": "Search",
    "tk.catalog.shown": "Showing {shown} of {total}",
    "tk.catalog.more": "Show more",
    "tk.catalog.empty_hint": "Try a different name or category.",
  },
};

export default dict;
